<template>
	<div class="nodata">
		<div class="disBetween nodataCont">
			<div class="line"></div>
			<div class="nodataText ">{{str}}</div>
			<div class="line"></div>
		</div>
		<slot></slot>
	</div>
</template>

<script>
	export default {
		name: "nodata",
		props: {
			str: {
				type: String,
				required: true,
				default: "5"
			}

		},
		data() {
			return {

			};
		},
		methods: {},

		computed: {},
		created() {},
	};
</script>

<style lang="scss" scoped>
	.nodata {
		width: 100%;
		height: 100%;
		.nodataCont{
			.line{
				width: 60%;
				height: 1px;
				background: #666666;
			}
			.nodataText{
				font-size: 12px;
				white-space: nowrap;
				color: #909090;
				margin: 0 10px;
			}
		}
	}
</style>
